"use strict";

var Strings = require("./dist/Strings");
module.exports = new Strings();



//////////////////
// WEBPACK FOOTER
// ./~/utiljs-strings/index.js
// module id = 172
// module chunks = 1